import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

export const Hero = () => {
  const i18n = useI18n();

  return (
    <div className="mb-[39px] bg-white border-b-[1px] border-black lg:mb-24">
      <section className="flex overflow-hidden flex-col-reverse items-center mx-auto  w-full  lg:flex-row lg:h-[500px]">
        <div className="flex basis-[50%] justify-end">
          <article className="flex flex-col gap-3 p-8 py-[24px] max-w-3xl h-full text-center lg:gap-6 lg:py-16 lg:text-left xl:pl-[120px]">
            <span className="self-center w-[28px] h-[28px] lg:mr-8 lg:w-[45px] lg:h-[45px]">
              <Image
                src={"/images/environment/leaf.webp"}
                alt="A green leaf"
                width="45"
                height="45"
              />
            </span>

            <h1 className="text-[36px] font-medium leading-[38px] md:text-[62px] md:leading-[72px]">
              {i18n.t("environment.title")}
            </h1>
            <p className="text-base font-normal leading-[25px] md:text-[18px] md:leading-[30px]">
              {i18n.t("environment.description")}
            </p>
          </article>
        </div>
        <div className="relative w-full h-[290px] max-h-[290px] border-b-[1px] border-black lg:w-1/2 lg:h-[500px] lg:max-h-[500px] lg:border-b-0 lg:border-l-[1px]">
          <Image
            src={"/images/environment/hero.webp"}
            layout="fill"
            className="object-cover object-center"
            alt="Women with a green pullover and an orange sleeveless jacket who held up her phone above her head"
            priority
            sizes="(min-width: 1024px) 50vw, 100vw"
          />
        </div>
      </section>
    </div>
  );
};
